module.exports = __webpack_public_path__ + "static/media/issue-estimate-summary.def50025.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/issue-estimate-summary.scss
// module id = 2140
// module chunks = 0